// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b2f6b87b","239":"b146f06f","455":"23ec1b57"}[chunkId] + ".chunk.js";
};